/**
 * @generated SignedSource<<79fc66e471dab27675ddcab7edb5e137>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type serviceCreditsToggleAutoRefillMutation$variables = {
  isActive: boolean;
  serviceName: ServicesWithCredits;
};
export type serviceCreditsToggleAutoRefillMutation$data = {
  readonly toggleAutoRefill: boolean;
};
export type serviceCreditsToggleAutoRefillMutation = {
  response: serviceCreditsToggleAutoRefillMutation$data;
  variables: serviceCreditsToggleAutoRefillMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isActive"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceName"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isActive",
        "variableName": "isActive"
      },
      {
        "kind": "Variable",
        "name": "serviceName",
        "variableName": "serviceName"
      }
    ],
    "kind": "ScalarField",
    "name": "toggleAutoRefill",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceCreditsToggleAutoRefillMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "serviceCreditsToggleAutoRefillMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "0e42955221ee9eefe92ae9b3d98bc16c",
    "id": null,
    "metadata": {},
    "name": "serviceCreditsToggleAutoRefillMutation",
    "operationKind": "mutation",
    "text": "mutation serviceCreditsToggleAutoRefillMutation(\n  $serviceName: ServicesWithCredits!\n  $isActive: Boolean!\n) {\n  toggleAutoRefill(serviceName: $serviceName, isActive: $isActive)\n}\n"
  }
};
})();

(node as any).hash = "e5b4715685eada71bc9bd45697e6bd58";

export default node;
